const Footer = () => {
    return (
        <footer className="bg-[#3955A3] dark:bg-white py-5 text-center text-white dark:text-black dark:border-t-2 font-pupylinux">
            <p className="font-light">Create with ❤️ by Arie Akbarull</p>
        </footer>
    )
}

export default Footer